import type { ReactNode } from 'react'

import { ThemeProvider } from '@/context/theme-context'
import { QueryProvider } from '@/integrations/query-provider'
import SentryProvider from '@/integrations/sentry'

interface AppProvidersProps {
  children: ReactNode
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryProvider>
      <SentryProvider>
        <ThemeProvider>{children}</ThemeProvider>
      </SentryProvider>
    </QueryProvider>
  )
}
